// Architectural UC hexagon monogram. Uses currentColor so it adapts to any bg.
export default function UCLogo({ className = "h-10 w-10" }) {
  return (
    <svg viewBox="0 0 100 108" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Upscale Concrete Services">
      <path
        d="M50 3 L92 27 L92 81 L50 105 L8 81 L8 27 Z"
        stroke="currentColor"
        strokeWidth="4"
        fill="none"
      />
      <text
        x="50"
        y="62"
        textAnchor="middle"
        fontFamily="'Bricolage Grotesque', sans-serif"
        fontWeight="800"
        fontSize="40"
        letterSpacing="-2"
        fill="currentColor"
      >
        UC
      </text>
      <line x1="24" y1="76" x2="76" y2="76" stroke="currentColor" strokeWidth="2.5" />
    </svg>
  );
}
